(() => {
  'use strict';

  if (customElements.get('cart-drawer')) return;

  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.overlay = this.querySelector('#CartDrawer-Overlay');
      this.inner = this.querySelector('.drawer__inner');

      this.handleKeyUp = this.handleKeyUp.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }

    connectedCallback() {
      this.overlay?.addEventListener('click', this.handleOverlayClick);
      this.addEventListener('keyup', this.handleKeyUp);

      this.querySelectorAll('.drawer__close').forEach(button => {
        button.addEventListener('click', () => this.close());
      });

      this.querySelectorAll('cart-drawer-items').forEach(items => {
        if (typeof items.init === 'function') {
          items.init();
        }
      });
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.handleOverlayClick);
      this.removeEventListener('keyup', this.handleKeyUp);
    }

    handleOverlayClick() {
      this.close();
    }

    handleKeyUp(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');

      const closeButton = this.querySelector('.drawer__close');

      if (closeButton) {
        setTimeout(() => closeButton.focus(), 50);
      }
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('cart-drawer', CartDrawer);


  /*
   * CART DRAWER ITEMS
   */

  if (!customElements.get('cart-drawer-items')) {
    class CartDrawerItems extends HTMLElement {

      connectedCallback() {
        this.init();
      }

      init() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
      }

      async handleClick(event) {
const removeButton = event.target.closest(
  '.cart-drawer-item__cart-remove-button'
);

if (removeButton) {
  event.preventDefault();

  const line =
    removeButton.dataset.index ||
    removeButton.closest('[data-index]')?.dataset.index;

  if (line) {
    await updateCartItem(line, 0);
  }

  return;
}

const button = event.target.closest('.quantity__button');

if (!button) return;

        event.preventDefault();

        const input = button.parentElement.querySelector('.quantity__input');

        if (!input) return;

        let quantity = parseInt(input.value, 10) || 0;

        if (button.name === 'plus') {
          quantity += parseInt(input.step, 10) || 1;
        }

        if (button.name === 'minus') {
          quantity -= parseInt(input.step, 10) || 1;
        }

        const min = parseInt(input.min, 10) || 0;
        const max = input.max ? parseInt(input.max, 10) : Infinity;

        quantity = Math.max(min, Math.min(max, quantity));

        await updateCartItem(input.dataset.index || input.closest('[data-index]')?.dataset.index, quantity);
      }

      async handleChange(event) {
        const input = event.target.closest('.quantity__input');

        if (!input) return;

        const quantity = parseInt(input.value, 10) || 0;

        const line =
          input.dataset.index ||
          input.closest('[data-index]')?.dataset.index;

        if (!line) return;

        await updateCartItem(line, quantity);
      }
    }

    customElements.define('cart-drawer-items', CartDrawerItems);
  }


  /*
   * CART HELPERS
   */

  async function updateCartItem(line, quantity) {
    try {
      const response = await fetch(
        window.routes?.cart_change_url || '/cart/change.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity)
          })
        }
      );

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      await refreshCartDrawer();

    } catch (error) {
      console.error('Cart update error:', error);
    }
  }


  async function refreshCartDrawer() {
    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`,
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        throw new Error('Cart drawer refresh failed');
      }

      const sections = await response.json();

      const html = sections['cart-drawer'];

      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (!newDrawer || !currentDrawer) return;

      const wasOpen = currentDrawer.classList.contains('active');

      currentDrawer.replaceWith(newDrawer);

      const drawer = document.querySelector('cart-drawer');

      if (wasOpen && drawer) {
        drawer.open();
      }

      await updateCartBubble();

    } catch (error) {
      console.error('Cart drawer refresh error:', error);
    }
  }


  async function updateCartBubble() {
    try {
      const response = await fetch(
        window.Shopify?.routes?.root + 'cart.js' || '/cart.js',
        {
          headers: {
            'Accept': 'application/json'
          }
        }
      );

      if (!response.ok) return;

      const cart = await response.json();

      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');

          const count = bubble.querySelector(
            '.cart-count-bubble span:not(.visually-hidden)'
          );

          if (count) {
            count.textContent = cart.item_count;
          }
        } else {
          bubble.classList.add('hidden');
        }
      });

    } catch (error) {
      console.error('Cart bubble update error:', error);
    }
  }


  /*
   * ADD TO CART
   */

  document.addEventListener('submit', async event => {
    const form = event.target.closest(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    /*
     * Don't interfere with forms explicitly configured
     * to skip the drawer.
     */
    const skipCart =
      form.querySelector('[data-skip-cart="true"]') ||
      form.closest('[data-skip-cart="true"]');

    if (skipCart) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    }

    try {
      const formData = new FormData(form);

      const response = await fetch(
        window.routes?.cart_add_url || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(
          error.description || 'Unable to add product to cart'
        );
      }

      await refreshCartDrawer();

      const drawer = document.querySelector('cart-drawer');

      if (drawer) {
        drawer.open();
      }

    } catch (error) {
      console.error('Add to cart error:', error);

      /*
       * Let the user see the actual Shopify error
       * instead of silently failing.
       */
      const errorElement =
        form.closest('product-form')
          ?.querySelector('.product-form__error-message');

      if (errorElement) {
        errorElement.textContent = error.message;
        errorElement.parentElement?.removeAttribute('hidden');
      }

    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
      }
    }
  });


  /*
   * CART ICON
   */

  document.addEventListener('click', event => {
    const cartLink = event.target.closest(
      '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"]'
    );

    if (!cartLink) return;

    const drawer = document.querySelector('cart-drawer');

    if (!drawer) return;

    event.preventDefault();
    drawer.open();
  });


  /*
   * INITIALIZATION
   */

  document.addEventListener('DOMContentLoaded', () => {
    updateCartBubble();
  });

})();
